import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import TranslationService from "../../../../Services/Translation/TranslationService";
import AutoTranslate from "../../../../Components/AutoTranslate";
import { Badge } from "react-bootstrap";

const Step2 = ({ stepLabels = [], onNext = () => {}, onPrev = () => {}, formData = {}, setFormData = () => {} }) => {
  const language = useSelector((state) => state.localStorage.language);
  const [ppeCheck, setPpeCheck] = useState(formData.ppeIssueStatus);
  const [ppeStep, setPpeStep] = useState(0);
  const [wording, setWording] = useState({
    placeholder: "상세한 답변을 입력해주세요...",
  });

  useEffect(() => {
    Init();
  }, []);

  const Init = async () => {
    const _placeholder = await TranslationService.translateText(wording.placeholder, language.lang);
    setWording({ ...wording, placeholder: _placeholder });
  };

  const handleHealthAnswer = (answer) => {
    const updatedHealthCheck = [...ppeCheck];
    updatedHealthCheck[ppeStep].checked = answer;
    setPpeCheck(updatedHealthCheck);
    setFormData({ ...formData, ppeIssueStatus: updatedHealthCheck });
  };

  const handleNoteChange = (note) => {
    const updatedHealthCheck = [...ppeCheck];
    updatedHealthCheck[ppeStep].note = note;
    setPpeCheck(updatedHealthCheck);
    setFormData({ ...formData, ppeIssueStatus: updatedHealthCheck });
  };

  // 모든 질문이 답변되었는지 확인
  const isAllAnswered = Array.isArray(ppeCheck) && ppeCheck.every((item) => item.checked !== "");

  return (
    <div className='flex-column-center-center gap-5 w-100'>
      <div className='step-form-container'>
        <div>
          <h2 className='step-form-title'>
            <AutoTranslate targetLanguage={language.lang}>{stepLabels[2]}</AutoTranslate>
          </h2>
          {Array.isArray(ppeCheck) && ppeCheck.length > 0 ? (
            <React.Fragment>
              <div className='flex-around-center'>
                {Array.isArray(ppeCheck) &&
                  ppeCheck.map((item, index) => {
                    return (
                      <Badge
                        key={index}
                        className='cursor-pointer'
                        pill
                        bg={`${item.checked === "" ? "white" : "success"}`}
                        text={`${item.checked === "" ? "black" : "white"}`}
                        style={{ border: `${ppeStep === index ? "2px solid #03bbfe" : ""}` }}
                        onClick={() => setPpeStep(index)}
                      >
                        {index + 1}
                      </Badge>
                    );
                  })}
              </div>
              <div className='question-container'>
                <h2 className='question-title'>
                  <AutoTranslate targetLanguage={language.lang}>{ppeCheck[ppeStep].label}</AutoTranslate>
                </h2>
                <div className='radio-button-group'>
                  <button
                    className={`radio-button ${ppeCheck[ppeStep].checked !== "" ? (ppeCheck[ppeStep].checked === true ? "selected" : "") : ""}`}
                    onClick={() => {
                      if (ppeStep < ppeCheck.length - 1) {
                        setPpeStep(ppeStep + 1);
                      }
                      handleHealthAnswer(true);
                    }}
                  >
                    <AutoTranslate targetLanguage={language.lang}>지급</AutoTranslate>
                  </button>
                  <button
                    className={`radio-button ${ppeCheck[ppeStep].checked !== "" ? (!ppeCheck[ppeStep].checked ? "selected" : "") : ""}`}
                    onClick={() => {
                      if (ppeStep < ppeCheck.length - 1) {
                        setPpeStep(ppeStep + 1);
                      }
                      handleHealthAnswer(false);
                    }}
                  >
                    <AutoTranslate targetLanguage={language.lang}>미지급</AutoTranslate>
                  </button>
                </div>
                {Array.isArray(ppeCheck) && ppeCheck[ppeStep].hasNote && ppeCheck[ppeStep].checked && (
                  <div className='additional-answer-container'>
                    <label className='additional-answer-label'>
                      <AutoTranslate targetLanguage={language.lang}>추가 설명을 입력해주세요</AutoTranslate>
                    </label>
                    <textarea className='additional-answer-input' placeholder={wording.placeholder} value={ppeCheck[ppeStep].note || ""} onChange={(e) => handleNoteChange(e.target.value)} rows={3} />
                  </div>
                )}
              </div>
            </React.Fragment>
          ) : (
            <div className='flex-column-center-center gap-3'>
              <p>
                <AutoTranslate targetLanguage={language.lang}>관리자가 등록한 보호구 지급 품목이 없습니다.</AutoTranslate>
              </p>
            </div>
          )}
        </div>
        <div className='step-button-group'>
          <button className='step-button step-button-secondary' onClick={onPrev}>
            <AutoTranslate targetLanguage={language.lang}>이전</AutoTranslate>
          </button>
          <button
            className={`step-button step-button-primary ${!isAllAnswered ? "disabled" : ""}`}
            onClick={() => {
              if (isAllAnswered) {
                onNext();
              }
            }}
            disabled={!isAllAnswered}
          >
            <AutoTranslate targetLanguage={language.lang}>다음</AutoTranslate>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Step2;
